import { CheckCircle, XCircle } from 'lucide-react'

import { Heading } from '@/ui-components/Heading'

export type AccountCapabilitiesData = {
  acceptFundsVia: {
    method: string
    daysToComplete?: string
    active: boolean
  }[]
  payoutVia: {
    method: string
    active: boolean
  }[]
}

const AccountCapabilities = ({ data }: { data: AccountCapabilitiesData }) => {
  return (
    <div className="mb-6 space-y-6 border rounded-lg border-gray-50 dark:border-gray-800">
      <Heading
        className="mb-0 p-4 sm:p-6"
        level={4}
      >
        Account Capabilities
      </Heading>

      <hr className="mb-0 border-gray-50 dark:border-gray-800" />

      <div className="flex flex-col gap-1 p-4 sm:p-6">
        {data.acceptFundsVia.length > 0 && (
          <>
            <span className="text-sm text-gray-500 dark:text-gray-400">Accept funds via</span>
            {data.acceptFundsVia.map((method, index) =>
              method.active ? (
                // Shows check and the days to complete
                <div
                  className="flex gap-2"
                  key={`${method.method}-${index}`}
                >
                  <CheckCircle className="size-4 mt-1 text-green-500 dark:text-green-400" />
                  <div className="flex flex-col">
                    <span className="font-medium text-gray-900 dark:text-white">{method.method}</span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">Takes {method.daysToComplete}</span>
                  </div>
                </div>
              ) : (
                // Shows x and no days to complete
                <div
                  className="flex gap-2 items-center text-gray-300 dark:text-gray-600"
                  key={`${method.method}-${index}`}
                >
                  <XCircle className="size-4" />
                  <span>{method.method}</span>
                </div>
              ),
            )}
          </>
        )}

        {data.payoutVia.length > 0 && (
          <>
            <span className="mt-2 text-sm text-gray-500 dark:text-gray-400">Payout via</span>
            {data.payoutVia.map((method, index) =>
              method.active ? (
                // Shows check and no days to complete
                <div
                  className="flex gap-2"
                  key={`${method.method}-${index}`}
                >
                  <CheckCircle className="size-4 mt-1 text-green-500 dark:text-green-400" />
                  <div className="flex flex-col">
                    <span className="font-medium text-gray-900 dark:text-white">{method.method}</span>
                  </div>
                </div>
              ) : (
                // Shows x and no days to complete
                <div
                  className="flex gap-2 items-center text-gray-300 dark:text-gray-600"
                  key={`${method.method}-${index}`}
                >
                  <XCircle className="size-4" />
                  <span>{method.method}</span>
                </div>
              ),
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default AccountCapabilities
